var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiglogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 106,
    viewBox: "0 0 170 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6436 5.15979L57.5431 2.69206L71.9007 0L70.6669 5.94497L67.3018 19.7418L39.8203 25.3503L44.6436 5.15979Z",
    fill: "#0862B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6984 30.5104L51.5979 28.0426L65.9556 25.3506L64.7217 31.2956L61.3566 45.0924L47.4476 106L25.3503 80.8744L32.7534 50.7009L13.909 54.4024L0 37.8014L38.6984 30.5104Z",
    fill: "url(#paint0_linear_573_1579)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6984 30.5104L51.5979 28.0426L65.9556 25.3506L64.7217 31.2956L61.3566 45.0924L47.4476 106L25.3503 80.8744L32.7534 50.7009L13.909 54.4024L0 37.8014L38.6984 30.5104Z",
    fill: "url(#paint1_linear_573_1579)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.48 31.745L130.902 29.9503L138.978 28.4921L146.157 26.6974L148.849 9.98417L78.9675 23.3323L75.2659 40.2699L98.934 36.0074L86.371 100.393L110.824 95.0085L121.48 31.745Z",
    fill: "url(#paint2_linear_573_1579)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.48 31.745L130.902 29.9503L138.978 28.4921L146.157 26.6974L148.849 9.98417L78.9675 23.3323L75.2659 40.2699L98.934 36.0074L86.371 100.393L110.824 95.0085L121.48 31.745Z",
    fill: "url(#paint3_linear_573_1579)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_1579",
    x1: 1.00952,
    y1: 38.2501,
    x2: 65.2825,
    y2: 25.9114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#086EBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02B3F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_1579",
    x1: 65.2825,
    y1: 26.4723,
    x2: 46.7746,
    y2: 104.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01B7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0869B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_573_1579",
    x1: 147.167,
    y1: 20.528,
    x2: 77.0238,
    y2: 24.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0862B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0862B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_573_1579",
    x1: 87.717,
    y1: 101.066,
    x2: 112.058,
    y2: 16.9386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0862B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BFFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiglogo);
export default __webpack_public_path__ + "static/media/biglogo.9a891f62c93524b92f8adf7c795a5a9e.svg";
export { ForwardRef as ReactComponent };